import EfSpec from '@elem/ui/ef-spec';
import EfTab, { EfTabItemProps } from '@elem/ui/ef-tab';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';
import EfSection from '@elem/ui/ef-section';
import EfLink from '@elem/ui/ef-link';
import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';
import { EU2_PAGE_DATA, EU2_PAGE_TAB_DATA, SITE, TabKeyEnum } from './common';

export default function TheComp() {
    const { locale = 'us', query } = useRouter();
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { pageStatus } = useProductStore();

    const listTabH = useMemo(() => {
        const data = EU2_PAGE_TAB_DATA[locale as SITE];
        const list = [
            {
                type: TabKeyEnum.solution,
                title: data.solution.title,
                href:
                    locale === 'ph'
                        ? 'https://ph.ecoflow.com/products/800w-alternator-charger'
                        : `https://${locale}.ecoflow.com/products/delta-3-series-portable-power-station`,
            },
            {
                type: TabKeyEnum.generator,
                title: data.generator.title,
                href:
                    locale === 'ph'
                        ? 'https://ph.ecoflow.com/products/delta-3-portable-power-station?variant=52064534987062'
                        : `https://${locale}.ecoflow.com/products/delta-3-solar-generator-pv220w`,
            },
        ];
        if (locale === 'uk') return list;
        return [
            {
                type: TabKeyEnum.system,
                title: data.system.title,
                href:
                    locale === 'ph'
                        ? 'https://ph.ecoflow.com/products/powerstream-microinverter'
                        : `https://${locale}.ecoflow.com/products/delta-3-series-portable-power-station`,
            },
            ...list,
        ];
    }, [locale]);
    // 选中的tab
    const [activeType, setActiveType] = useState<TabKeyEnum>(locale === 'uk' ? TabKeyEnum.solution : TabKeyEnum.system);
    // tab切换回调
    const activeTypeCallback = (item: EfTabItemProps) => {
        setActiveType(item.type as TabKeyEnum);
    };

    // 12.5 15:00 ~ 12.19 14:59 这段时间，不显示EU2
    const isDisableLinkText = useMemo(() => {
        const now = query._timer ? new Date(query?._timer as string) : new Date();
        const end = new Date('2024/12/19 15:00:00 GMT+8');
        return now < end;
    }, [query._timer]);

    // 不是 statusB，或者不是EU站点，不渲染
    if (!IS_EU_SITES) return null;
    if (pageStatus !== 'statusB') return null;
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} theme="black" title={EU2_PAGE_DATA[locale as SITE].title} />
            <div className="box">
                <div className="box-img">
                    <EfImg
                        pc={EU2_PAGE_TAB_DATA[locale as SITE][activeType].pcImg ?? ''}
                        pad={EU2_PAGE_TAB_DATA[locale as SITE][activeType].padImg ?? ''}
                        // pc="https://websiteoss.ecoflow.com/upload/image/1730084017958/eu-delta3-pc.jpg"
                        // pad="https://websiteoss.ecoflow.com/upload/image/1730084037906/eu-delta3-pad.jpg"
                        // h5="https://websiteoss.ecoflow.com/upload/image/1730084053867/eu-delta3-h5.jpg"
                    />
                </div>
                <div className="box-msg">
                    <div className="box-title">{EU2_PAGE_TAB_DATA[locale as SITE][activeType].title}</div>
                    <div className="box-desc">{EU2_PAGE_TAB_DATA[locale as SITE][activeType].desc}</div>
                    {isDisableLinkText ? (
                        <div className="box-link disable">{EU2_PAGE_DATA[locale as SITE].disableLinkText}</div>
                    ) : (
                        <EfLink
                            className="box-link"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: 'DELTA 3 SERIES',
                                position: `Product Detail_${EU2_PAGE_DATA[locale as SITE].linkText}`,
                            }}
                            href={listTabH.find((item) => item.type === activeType)?.href}
                        >
                            {EU2_PAGE_DATA[locale as SITE].linkText}
                        </EfLink>
                    )}
                </div>
            </div>
            <EfTab theme={'white'} items={listTabH} activeType={activeType} onChange={activeTypeCallback} />
        </div>
    );
}
